import { Component } from '@angular/core';

@Component({
    selector: 'app-external',
    templateUrl: './external.component.html',
    styleUrl: './external.component.scss',
    standalone: false
})
export class ExternalComponent {

}
